const modelValidationLogEn = {
	modelValidationLogTable: 'Model Validation Log',
	timestamp: 'Timestamp',
	tag: 'Tag',
	objective: 'Objective',
	state: 'State',
	name: 'Name',
	modelValidationLogEditForm: 'Model Validation Log',
	basic: 'Basic',
	table_name: 'Table Name',
	description: 'Description',
	fields: 'Fields',
	type: 'Type',
	userGroup: 'User Group'
};

export default modelValidationLogEn;